const baseURL = 'https://v6.exchangerate-api.com/v6';

const getCurrentRate = (baseCurrency, targetCurrency) => {
    const fullURL = `${baseURL}/${process.env.REACT_APP_EXCHANGE_API}/pair/${baseCurrency}/${targetCurrency}`; 
    return fetch(fullURL).then(response => response.json())
        .catch(err => console.log(err));
} 


export default getCurrentRate;